import { type ReactNode, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { RegistrationProvider } from '../../contexts/registrationProvider';
import { useRegistrationContext } from '@/contexts/registrationContext';

const RegistrationBoundary = ({ children }: { children: ReactNode }) => {
  const { resetRegistrationContext } = useRegistrationContext();

  useEffect(() => {
    return () => {
      resetRegistrationContext();
    };
  }, []);

  return <>{children}</>;
};

const RegistrationRouteWrapper = () => {
  return (
    <RegistrationProvider>
      <RegistrationBoundary>
        <Outlet />
      </RegistrationBoundary>
    </RegistrationProvider>
  );
};
export default RegistrationRouteWrapper;
